import _get from 'lodash/get';
import { FRONTSPACE, PROFILES_GATE } from '@bedrock-rdk/constants';
import CTA from './cta.constants';
import { getCurrentSectionCode } from '../../logic/layout/layout.selectors';

export const getItemTargetValue = target => Object.keys(target).filter(value => value.includes('value_'))[0];

export const getItemAnalyticsEvent = item => _get(item, 'action.analytics', _get(item, 'analytics'));

export const shouldRefreshAliasHome = (section, state) => {
  const currentSectionCode = getCurrentSectionCode(state);

  return section !== currentSectionCode;
};

export const getItemActionType = item => {
  if (!item) {
    return null;
  }

  const target = item.action ? item.action.target : item.target;

  if (!target) {
    return item.id;
  }

  const targetValue = getItemTargetValue(target);
  const metadata = target[targetValue];

  const type = metadata.type || metadata.reference || target.type;

  if (type === FRONTSPACE && metadata.id === PROFILES_GATE) {
    return CTA.PROFILES_GATE;
  }

  return type;
};

export const getTargetData = item => {
  const target = _get(item, 'action.target');

  if (!target) {
    return {
      id: item.id,
    };
  }

  const targetValue = getItemTargetValue(target);

  return target[targetValue];
};

export const getSectionCode = item => {
  const target = _get(item, 'action.target');

  try {
    const targetTypeMap = { layout: 'value_layout' };
    const targetValue = targetTypeMap[target.type] || 'value_app';
    const { section } = target[targetValue];

    return section;
  } catch {
    return null;
  }
};

export const shouldStoreVideoRoute = hash => !/\/video\/.+/.test(hash);
